import { observable, action, decorate } from "mobx";

class State {
  lightBoxImage = undefined;
  setLightBox (newImage) {
    this.lightBoxImage = newImage;
  }
}

decorate(State, {
  lightBoxImage: observable,
  setLightBox: action
});

export default new State();


// WEBPACK FOOTER //
// ./src/store.js